import { CoreDataDictionaryViewsName } from './name';
import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { DataDictionaryView } from '@types';
import { getCoreDataDictionaryViewsAsyncSlice } from './get';

export const updateCoreDataDictionaryViewsSyncSlice = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: CoreDataDictionaryViewsName,
	state: getCoreDataDictionaryViewsAsyncSlice.asyncState,
	target: (update: Partial<DataDictionaryView>) => (entry) => entry.id === update.id,
	update: (update: Partial<DataDictionaryView>) => (entry) => ({
		...entry,
		...update
	})
});
